"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.AppSwitcherContent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _AppSwitcherFooter = _interopRequireDefault(require("./AppSwitcherFooter"));

var _Header = _interopRequireDefault(require("./Header"));

var _NavMenuDivider = _interopRequireDefault(require("../../NavMenuDivider"));

var _Product = _interopRequireDefault(require("./Product"));

var _fetchProductsActivationInfo = require("../../../../../api/fetch-products-activation-info");

var _links = require("../links");

var _fetchProductsActivationInfo2 = require("../../../../../api/mocks/fetch-products-activation-info");

var _productsStatus = require("../productsStatus");

var AppSwitcherContent = function AppSwitcherContent(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      _onLinkClick = _ref.onLinkClick,
      products = _ref.products,
      swicusOrgId = _ref.swicusOrgId,
      inverted = _ref.inverted;

  var _useState = (0, _react.useState)((0, _productsStatus.generateInitialProductsStatus)(currentProduct)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      productsStatus = _useState2[0],
      setProductsStatus = _useState2[1];

  (0, _react.useEffect)(function () {
    if (swicusOrgId) {
      setProductsActivationInfo();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    inverted: inverted
  }), /*#__PURE__*/_react["default"].createElement(_NavMenuDivider["default"], null), products.map(function (product) {
    var productStatus = productsStatus[product.id];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: product.id
    }, /*#__PURE__*/_react["default"].createElement(_Product["default"], (0, _extends2["default"])({}, product, {
      url: (0, _links.getLink)(currentProduct, environment, products, product.id, productsStatus, swicusOrgId),
      features: features,
      inverted: inverted,
      productStatus: productStatus,
      swicusOrgId: swicusOrgId,
      onLinkClick: function onLinkClick() {
        return _onLinkClick(product.id, productStatus);
      }
    })), /*#__PURE__*/_react["default"].createElement(_NavMenuDivider["default"], null));
  }), /*#__PURE__*/_react["default"].createElement(_AppSwitcherFooter["default"], {
    onLinkClick: function onLinkClick() {
      return _onLinkClick();
    }
  }));

  function setProductsActivationInfo() {
    return _setProductsActivationInfo.apply(this, arguments);
  }

  function _setProductsActivationInfo() {
    _setProductsActivationInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var mockedApi, crossActivation, getProductsActivationInfo, info, noStatusReceived;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mockedApi = features && features.mockActivationApi;
              crossActivation = features && features.crossActivation;
              getProductsActivationInfo = mockedApi ? _fetchProductsActivationInfo2.mockedFetchProductsActivationInfo : _fetchProductsActivationInfo.fetchProductsActivationInfo;

              if (!crossActivation) {
                _context.next = 18;
                break;
              }

              _context.prev = 4;
              _context.next = 7;
              return getProductsActivationInfo(environment, swicusOrgId);

            case 7:
              info = _context.sent;
              setNewProductsStatus(info.products);
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              noStatusReceived = (0, _productsStatus.generateStatusForAllProducts)(_productsStatus.PRODUCT_STATUS.NO_STATUS);
              setNewProductsStatus(noStatusReceived); // eslint-disable-next-line no-console

              console.error(_context.t0);

            case 16:
              _context.next = 19;
              break;

            case 18:
              setNewProductsStatus((0, _productsStatus.generateStatusForAllProducts)(_productsStatus.PRODUCT_STATUS.CAN_SWITCH));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11]]);
    }));
    return _setProductsActivationInfo.apply(this, arguments);
  }

  function setNewProductsStatus(productsStatus) {
    productsStatus[currentProduct] = _productsStatus.PRODUCT_STATUS.CURRENT_PRODUCT;
    setProductsStatus(productsStatus);
  }
};

exports.AppSwitcherContent = AppSwitcherContent;
var _default = AppSwitcherContent;
exports["default"] = _default;